import { AvailabilityReminderModal } from '@web-app/components/AvailabilityReminderBanner/AvailabilityReminderModal';
import Navbar from '@web-app/components/Navbar';
import { ProviderEvents } from '@web-app/components/ProviderEvents/ProviderEvents';
import { ShellBanners } from '@web-app/components/Shell/ShellBanners';
import { ShellContributionsProvider } from '@web-app/components/Shell/ShellContributions';
import { ShellReminderModal } from '@web-app/components/Shell/ShellReminderModal';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';

const ROUTES_WITHOUT_NAVBAR = [
  '/sign-in',
  '/sign-up',
  '/[roomId]',
  '/call/meal-plan/[roomId]',
];

interface PersistentLayoutProps {
  children: ReactNode;
}

export const PersistentLayout = ({ children }: PersistentLayoutProps) => {
  const router = useRouter();

  const isPageWithoutNavbar = ROUTES_WITHOUT_NAVBAR.some(
    (pattern) =>
      router.route === pattern || router.route.startsWith(`${pattern}/`),
  );

  const shouldShowNavbar = !isPageWithoutNavbar;

  return (
    <>
      <ProviderEvents />
      {shouldShowNavbar && (
        // Feature contributions run only where the shell renders them.
        <ShellContributionsProvider>
          <Navbar />
          <ShellBanners />
          <ShellReminderModal />
        </ShellContributionsProvider>
      )}
      {children}
      {shouldShowNavbar && <AvailabilityReminderModal />}
    </>
  );
};
